<template>

    <div class="container ">




        <div class="wrap">

            <transition name="fade">
                <h3 class="entry-title" v-if="showThanks"> <i class="fas fa-check"></i> Dziękujemy za Podpisanie umowy, poinformujemy Cię o wypłacie pożyczki e-mailem oraz sms. </h3>
            </transition>


            <transition name="slide-fade" @after-leave="signDone">
                <h3 class="entry-title" v-if="!isSigned"> <i class="fas fa-file-signature"></i> Poniżej znajduje się Twoja Umowa,
                 po jej podpisaniu ostatecznie zweryfikujemy Twój wniosek. </h3>
            </transition>


            <p class="col-10 mx-auto yellow-card"><strong>Po podpisaniu umowy nasze biuro ostatecznie zweryfikuje Twój wniosek.
Weryfikacja zazwyczaj trwa kilkanaście minut, a o jej przebiegu poinformujemy Cię mailowo. Nasze biuro weryfikuje wnioski od poniedziałku do piątku w godzinach od 9 do 17. <br><br>

Jeżeli decyzja będzie pozytywna, wyślemy Twoją pożyczkę przelewem natychmiastowym bluecash na Twoje konto i poinformujemy Cię o tym SMS
</strong></p>



          <div class="col-12 mx-auto" style="width: 75%;">
            <iframe height="600px" width="100%"  src="#/pdf" ></iframe>
          </div>



          <SignContract v-if="showSignature"  label="Podpisz Umowę" @signed="signedTerms"/>


        </div>

    </div>

</template>

<script>

    import __CFG from '@/conf/config.json';

    import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js';


    import axios from 'axios';

    import { bus } from './main';

    import SignContract from '@/components/SignContract';


    export default {

       name: 'ZetosThankYouView',
       components: { SignContract, VuePdfEmbed },


       data(){

            return {

                isSigned: false,

                showThanks: false,

                showSignature: true
            }
       },


       computed: {

       },
       methods: {

        signDone(){


            this.showThanks = true;

        },


        signedTerms(){


            this.signTerms();


            this.isSigned = true;


            this.showSignature = false;



        },


        signTerms() {

           var page = this.$root.mainpage;


            axios.post( __CFG.secondaryEndpoint + '/accept')
              .then(response => {


                if (!!response.data) {

                  let ok = !(response.data.IS_ERROR | 0);


                  console.log('acccepted  ')

                }
              })
              .catch(error => {

                           // Error
                  if (error.response) {

                     console.log(error.response);
                  }
              });

        },


        gotomain(){

            this.$router.push({path: '/'});
        }
       },




       mounted(){



            // scroll to top with .5s delay
            this.pageTop();

       }




    }
</script>

<style scoped>


h3 i {
    color: #0bc268;
}


.entry-title {


    font-size:32px;
    margin: 2.8em 0 2em;

    text-align: center;

}


.form-btn-wrap {

  margin-top: .5rem;
  padding: 2rem 1rem;

  display: flex;
  justify-content:center;
}

.button {

    cursor:pointer;
    min-width:260px;
    font-size: 16px;
    padding: 16px 40px;
    transition: ease-out 1s;
    line-height: 16px;

    border-radius:10px;
    border:0px;

    margin: 0 .5rem;

}

.button.btn-prev {

  background-color: #dfdfdf;
  color: rgb(64, 64, 64);
}

.button.btn-prev:hover {
  box-shadow: inset -400px 0 0 0 #bebebe;
}






.fade-enter-active,.fade-leave-active {
  transition: opacity 3s
}
.fade-enter,.fade-leave-active {
  opacity: 0
}


.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,.slide-fade-leave-active {
  padding-left: 10px;
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/ZetosThankYouView.vue